module.exports = __webpack_public_path__ + "static/media/menu_icon_interestcheck_normal.90420b6e.png";